import React from "react";
import { Container } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useRouter } from "next/router";

const BreadCrumb = ({ heading, description = "" }) => {
    const { locale } = useIntl();
    const { pathname } = useRouter();
    const shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
    return (
        <div
            className="breads wrapper"
            style={{
                backgroundColor: "rgb(112 96 166 / 100%)"
            }}
        >
            <div className="inner">
                <Container>
                    <h1 className="unique-bold h3">
                        {heading?.[locale] ?? heading}
                    </h1>
                    {(description?.[locale] || description?.length > 0) && (
                        <ul>
                            {!shouldHidePath && (
                                <li>{description?.[locale] ?? description}</li>
                            )}
                        </ul>
                    )}
                </Container>
            </div>
        </div>
    );
};

export default BreadCrumb;
